module.exports = __webpack_public_path__ + "img/gift-line.520f2e1e.svg";